import { StyleSheet } from 'react-native';
import { innerHeight, pt } from '../common/utils';

export default StyleSheet.create({
    container: {
        backgroundColor: '#E6EEF5',
        flex: 1,
        height: '100%'
    },
    main: {
        flex: 1
    },
    /* 导航条 start */
    nav_wrap: {
        position: 'absolute',
        top: 0,
        zIndex: 4,
        elevation: 4,
        width: '100%'
    },
    nav_btn: {
        width: pt(36),
        height: pt(36),
        marginHorizontal: pt(8),
        resizeMode: 'contain',
        marginLeft: pt(5)
    },
    focus: {
        // marginTop: pt(8),
        marginLeft: pt(8),
        flexDirection: 'row',
        alignItems: 'center'
    },
    center_wrap: {
        width: pt(274),
        height: pt(36),
        flexDirection: 'row',
        alignItems: 'center'
    },
    center_wrap_bg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: pt(274),
        height: pt(36)
    },
    center_pos: {
        marginLeft: pt(15),
        width: pt(30),
        textAlign: 'center',
        color: '#666',
        fontSize: pt(14)
    },
    center_more: {
        marginLeft: pt(2),
        width: pt(7),
        height: pt(5),
        resizeMode: 'contain'
    },
    center_search: {
        marginLeft: pt(13),
        width: pt(14),
        height: pt(14),
        resizeMode: 'contain'
    },
    center_search_placeholder: {
        marginLeft: pt(5),
        textAlign: 'left',
        color: '#ababab',
        fontSize: pt(12)
    },
    /* 导航条 end */

    banner: {
        height: pt(213),
        width: pt(375),
        alignItems: 'center',
        justifyContent: 'center'
    },
    hot_wait: {
        marginBottom: pt(9),
        marginTop: pt(-15),
        backgroundColor: '#fff',
        borderTopLeftRadius: pt(6),
        borderTopRightRadius: pt(6)
    },
    // no_banner: {
    //     marginTop: pt(60),
    //     marginBottom: pt(9)
    // },
    check_type: {
        height: pt(45),
        backgroundColor: '#fff',
        borderTopLeftRadius: pt(6),
        borderTopRightRadius: pt(6),
        flexDirection: 'row',
        justifyContent: 'center'
    },
    type_item: {
        marginRight: pt(40)
    },
    type_item_last: {
        marginRight: 0
    },
    // type_left: {
    //     flex: 1,
    //     alignItems: 'flex-end',
    //     paddingRight: pt(40)
    // },
    // type_right: {
    //     flex: 1,
    //     alignItems: 'flex-start',
    //     paddingLeft: pt(40)
    // },
    type_wrap: {
        justifyContent: 'center',
        alignItems: 'center',
        height: pt(45),
        width: pt(55)
    },
    type_text: {
        color: '#666',
        fontSize: pt(13),
        marginBottom: pt(3)
    },
    under_line: {
        backgroundColor: '#fff',
        height: pt(2),
        width: pt(24),
        borderRadius: pt(3)
    },
    under_line_cur: {
        backgroundColor: '#F0250F'
    },
    type_cur: {
        fontWeight: 'bold',
        color: '#F0250F'
    },
    pre_want_wrap: {
        backgroundColor: '#fff'
    },
    pre_time: {
        fontSize: pt(17),
        fontWeight: 'bold',
        paddingLeft: pt(10),
        paddingTop: pt(16),
        backgroundColor: '#fff'
    },
    pre_week: {
        color: '#666',
        fontSize: pt(12),
        paddingLeft: pt(5)
    },
    to_top: {
        position: 'absolute',
        right: pt(5),
        bottom: pt(100)
    },
    to_top_icon: {
        width: pt(50),
        height: pt(50)
    },
    special_price: {
        position: 'absolute',
        right: pt(5),
        bottom: pt(55),
        width: pt(120),
        height: pt(48)
    },
    container1: {
        // height: innerHeight - pt(50)
        // height: pt(620)
    },
    dialog: {
        padding: pt(20)
    },
    dialog_txt: {
        fontSize: pt(15)
    },
    gray: {
        color: '#898989'
    },

    offten_wrap: {
        marginTop: pt(4)
    },
    offten_go_wrap: {
        height: pt(70),
        paddingLeft: pt(10)
    },
    zIdex: {
        zIndex: 1
    }
});
